<template>
  <template v-if="_menu.children != undefined">
    <el-sub-menu :index="_menu.path">
      <template #title>{{ _menu.name }}</template>
      <MenuChildren v-for="item,index in _menu.children" :menu="item" :index="item.path" :key="index">{{ item.name }}</MenuChildren>
    </el-sub-menu>
  </template>
  <template v-else>
    <el-menu-item :index="_menu.path">{{ _menu.name }}</el-menu-item>
  </template>
</template>
<script>
export default {
  name: 'MenuChildren',
  props: ['menu', 'index'],
  data() {
    return {
      _menu: {},
      _index: '',
    }
  },
  mounted(){
  },
  watch:{
    menu: {
      immediate: true,
      handler(newVal){
        if(newVal != undefined){
          this._menu = newVal;
        }
      },
      deep: true,
    },
    index: {
      immediate: true,
      handler(newVal){
        this._index = newVal;
      }
    }
  }
}
</script>